import { Component, OnInit, OnDestroy, ChangeDetectorRef, OnChanges, SimpleChanges, AfterViewInit, HostListener, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import { MessageService, BUS_EVENTS } from 'src/app/common/events/message.service';
import { Subscription } from 'rxjs';
import { RsbService } from 'src/app/service/rsb.service';
import { Message } from 'src/app/common/events/message';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/common/events/notificationservice';
import { FormBuilder, FormGroup } from '@angular/forms';
import { APIURL } from 'src/app/common/api-url.constants';


@Component({
  selector: 'rsb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  visibleDropdown: boolean = false;
  isMobileLayout: boolean = false
  @ViewChild('fullcalendar') calendarComponent!: FullCalendarComponent;
  constructor(public lookupModel: RsbLookupModel,
    private router: Router,
    private rsbSrvice: RsbService,
    private toast: ToastrService,
    private notify: NotificationService,
    public rsbLookup: RsbLookupModel
  ) {

  }
  ngOnInit(): void {
    this.isMobileLayout = window.innerWidth <= 1024;
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1024;
    this.notify.getCalendarData();
  }

  get isSearchPropertiesRoute(): boolean {
    return this.router.url.startsWith('/search/');
  }

  logout(): void {
    this.rsbSrvice.franchiseLogout({ franchiseId: this.lookupModel.getLoggedUser().franchiseId, mobile: this.lookupModel.getLoggedUser()?.personalDetails?.mobile }).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.toast.success('User Logout Successfully')
        this.router.navigate(['login'])

      }
    })


  }




  calander(): void {
    this.router.navigate(['calander'])
  }
  profile(): void {
    // window.location.href= APIURL.WEBSITE_URL+'/account/myprofile'
    this.closeDropdown();
    this.router.navigate(['/account/associateMyProfile'])
  }
  favoriteListing() {
    this.closeDropdown();
    this.router.navigate(['/account/favorite-listings'])

    // window.location.href= APIURL.WEBSITE_URL+'/account/favorites'
  }

  routeRedirect(path) {
    document.body.classList.remove('sb-sidenav-toggled')
    this.router.navigate([path])
  }

  toggleBlockedClass() {
    document.body.classList.add('sb-sidenav-toggled');
  }
  getLeadsForProperties() {
    this.closeDropdown();
    this.router.navigate(['/account/leads-properties'])

  }
  changepwd() {
    this.closeDropdown();
    this.router.navigate(['/account/change-password'])
    // window.location.href= APIURL.WEBSITE_URL+'/account/changepassword'
  }
  closeDropdown() {
    this.visibleDropdown = false;
  }
}